import locale from './locale';
import localeForm from './localeForm';
import localeShort from './localeShort';

export const pt = locale;
export const ptForm = localeForm;
export const ptShort = localeShort;

export default {
  pt,
  ptForm,
  ptShort,
};
